import * as signalR from "@microsoft/signalr";
import { ref } from "vue";
import { getToken } from "@/utils/cookies";
import store from "@/store";
function getTokenSignal() {
  return getToken().replace("Bearer ", "");
}

export function useSignalR() {
  const connection = ref(null);
  const baseUrl = process.env.VUE_APP_BASE_API.replace("/api", "/");
  const messages = ref([]);
  const deviceCount = ref({ errorCount: 0, warningCount: 0 });

  const startConnection = async () => {
    if (connection.value) return;
    connection.value = new signalR.HubConnectionBuilder()
      .withUrl(
        `${baseUrl}hubs/deviceMonitoring?access_token=${encodeURIComponent(
          getTokenSignal()
        )}`,
        {
          transport: signalR.HttpTransportType.WebSockets
        }
      )
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.None)
      .build();

    connection.value.on("ReceiveMonitoring", count => {
      const prevError = deviceCount.value.errorCount;
      const prevWarning = deviceCount.value.warningCount;

      if (count.errorCount > prevError || count.warningCount > prevWarning) {
        store.commit("setHasNewHealthNotif", true);
      }

      deviceCount.value = count;
    });

    connection.value.on("MonitoringMessage", message => {
      window.dispatchEvent(
        new CustomEvent("new-monitoring-message", {
          detail: message
        })
      );
    });

    try {
      await connection.value.start();
      await connection.value.invoke("RequestCurrentCount");
    } catch {
      deviceCount.value = 0;
    }
  };

  const stopConnection = () => {
    if (connection.value) {
      connection.value.stop();
    }
  };

  const setNotifAsSeen = () => {
    store.commit("setHasNewHealthNotif", false);
  };

  return {
    connection,
    messages,
    setNotifAsSeen,
    deviceCount,
    startConnection,
    stopConnection
  };
}
